@if (model != null && option != null && (!model.readOnly || selection?.selected) ) {
<div [style.background-color]="option.color != null ? option.color : null" [formGroup]="formGroup">
  @if (!model.readOnly) {
  <sc-flex [startAligned]="true">
    <sc-checkbox-field formControlName="selection"
      [label]="('' | translate:[option.nameDictionaryKey, translationService.language])+(model.optionStatus.get(option.id)?.includes('required')?'*':'')">
    </sc-checkbox-field>
  </sc-flex>
  }
  @if (model.readOnly) {
  <div>
    <sc-dictionary-label [dictionaryKey]="option.nameDictionaryKey"></sc-dictionary-label>
  </div>
  }
  @if (showDriverHints && option.hintDriverDictionaryKey != null && (selection?.selected || option.allwaysShowHint) &&
  translationService.translationExists(option.hintDriverDictionaryKey, translationService.language)) {
  <div class="readonly-label">
    <sc-hint-legacy [dictionaryKey]="option.hintDriverDictionaryKey"></sc-hint-legacy>
  </div>
  }
  @if (selection?.selected) {
  <div class="option-details no-field-space">
    <sc-flex vertical stretchContent [gap]="8">
      @if (model?.loadingEnabled && (option.amountOfPallettesMandatory || option.amountOfBoxesMandatory ||
      option.amountInKilogrammMandatory || option.amountInLiterMandatory || option.amountOthersMandatory)) {
      <sc-content-spacer vertical half></sc-content-spacer>
      <sc-sub-title>
        <sc-dictionary-label dictionaryKey="shared.transport-options-editor.amount-of-cargo"></sc-dictionary-label>
      </sc-sub-title>
      @if (option.amountOfPallettesMandatory && !model.readOnly) {
      <sc-number-field formControlName="amountOfPallettes"
        labelDictionaryKey="tmc-yard.entity.transport-option.amount-of-pallettes">
      </sc-number-field>
      }
      @if (option.amountOfPallettesMandatory && selection.amountOfPallettes > 0 && model.readOnly) {
      <div class="readonly-label">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-of-pallettes"></sc-dictionary-label>:&nbsp;
        {{selection.amountOfPallettes}}
      </div>
      }
      @if (option.amountOfBoxesMandatory && !model.readOnly) {
      <sc-number-field formControlName="amountOfBoxes"
        labelDictionaryKey="tmc-yard.entity.transport-option.amount-of-boxes">
      </sc-number-field>
      }
      @if (option.amountOfBoxesMandatory && selection.amountOfBoxes > 0 && model.readOnly) {
      <div class="readonly-label">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-of-boxes"></sc-dictionary-label>:&nbsp;
        {{selection.amountOfBoxes}}
      </div>
      }
      @if (option.amountInKilogrammMandatory && !model.readOnly) {
      <sc-number-field formControlName="amountInKilogramm"
        labelDictionaryKey="tmc-yard.entity.transport-option.amount-in-kilogramm">
      </sc-number-field>
      }
      @if (option.amountInKilogrammMandatory && selection.amountInKilogramm> 0 && model.readOnly) {
      <div class="readonly-label">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-in-kilogramm"></sc-dictionary-label>:&nbsp;
        {{selection.amountInKilogramm}}
      </div>
      }
      @if (option.amountInLiterMandatory && !model.readOnly) {
      <sc-number-field formControlName="amountInLiter"
        labelDictionaryKey="tmc-yard.entity.transport-option.amount-in-liter">
      </sc-number-field>
      }
      @if (option.amountInLiterMandatory && selection.amountInLiter> 0 && model.readOnly) {
      <div class="readonly-label">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-in-liter"></sc-dictionary-label>:&nbsp;
        {{selection.amountInLiter}}
      </div>
      }
      @if (option.amountOthersMandatory && !model.readOnly) {
      <sc-string-field formControlName="amountOthers"
        labelDictionaryKey="tmc-yard.entity.transport-option.amount-others">
      </sc-string-field>
      }
      @if (option.amountOthersMandatory && selection.amountOthers?.trim().length > 0 && model.readOnly) {
      <div class="readonly-label">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-others"></sc-dictionary-label>:&nbsp;
        {{selection.amountOthers}}
      </div>
      }
      }
      @if (option.parameter && option.parameter.length > 0 && model.parametersEnabled) {
      <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.control.ui.transport-option-panel.parameters"></sc-dictionary-label></sc-sub-title>
      @for (parameter of option.parameter; track $index){
      @if (!model.readOnly && parameter.show) {
      <app-transport-option-parameter formControlName="parameter_{{parameter.id}}" [transportOption]="option"
        [parameter]="parameter"></app-transport-option-parameter>
      }
      @if(model.readOnly && selection) {
      <sc-flex>
        <sc-dictionary-label [dictionaryKey]="''+option.id"></sc-dictionary-label>
        <ng-container *ngFor="let param of parameter.parameterValues; let i = index">
          <ng-container *ngIf="i > 0">
            ,
          </ng-container>
          <sc-dictionary-label
            [dictionaryKey]="'dd.transport-option-parameter-value.' + param.id + '.value'"></sc-dictionary-label>
        </ng-container>
      </sc-flex>
      }
      }
      }
    </sc-flex>
    @for (subOption of option.options; track subOption) {
    @if (showInternalTransportOptions || subOption.onlyInternal !== true) {
    <app-transport-option-entry [option]="subOption" [model]="model"
      [showDriverHints]="showDriverHints"></app-transport-option-entry>
    }
    }
  </div>
  }
</div>
}
